/**
 * All prefixes created or modified here should reflect in the ERROR_CODES.md documentation.
 *
 * {@link https://github.azc.ext.hp.com/jarvis/react-portal-oobe-mfe/blob/develop/ERROR_CODES.md}
 */

import {
  GetValueByKey,
  RestrictedMap,
  RestrictedMapKeyType,
  RestrictedMapValueType,
} from 'restricted-map-typescript'

import { ApisClassPrefixMap, APIS_CLASS_PREFIX_MAP } from './apis-prefix'

/**
 * Error code prefixes to identify the source of the error.
 * The `XX` is a reserved prefix for unexpected errors.
 */
export enum ErrorPrefix {
  /** App dependencies or internal app errors */
  APP = 'AP',
  /** Content Stack errors */
  CMS = 'CS',
  /** Device HTTP Proxy errors */
  DHP = 'DH',
}

export type ApiPrefix = Extract<
  RestrictedMapValueType<ApisClassPrefixMap>,
  string
>

export type ApiPrefixClass = Exclude<
  RestrictedMapKeyType<ApisClassPrefixMap>,
  string
>

/**
 * API prefixes to identify the source of the error.
 * This const is auto-generated from {@link APIS_CLASS_PREFIX_MAP}
 */
export const API_PREFIX = new RestrictedMap(APIS_CLASS_PREFIX_MAP)

/** Gets an API Prefix by the client class */
export type ApiPrefixByClass<T extends ApiPrefixClass> = GetValueByKey<
  ApisClassPrefixMap,
  T
>
